import { render } from "./BrdcmChartStatusHelp.vue?vue&type=template&id=230bdf63&scoped=true&ts=true"
import script from "./BrdcmChartStatusHelp.vue?vue&type=script&lang=ts"
export * from "./BrdcmChartStatusHelp.vue?vue&type=script&lang=ts"

import "./BrdcmChartStatusHelp.vue?vue&type=style&index=0&id=230bdf63&scoped=true&lang=css"

import exportComponent from "/builds/vrs/docker/web/app/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-230bdf63"]])

export default __exports__